import React, { useState } from 'react';
import { Button } from '../../../components/Buttons';
import sessionTimelineService from '../../../services/sessionTimelineService';
import windowService from '../../../services/windowService';
import { handleError } from '../../../utils/apiUtils';

type Props = {
  curriculumId: string;
  timelineId: string;
  timelineCustomizationId: string | undefined;
  ButtonComponent: typeof Button;
  curriculumName: string;
  curriculumAgeCategory: string;
  sessionScheduledDate: string;
  timelineName: string | undefined;
};

export const DownloadPresentationMediaButton = ({
  curriculumId,
  timelineId,
  timelineCustomizationId,
  curriculumName,
  curriculumAgeCategory,
  sessionScheduledDate,
  timelineName,
  ButtonComponent,
}: Props) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const archiveName =
    curriculumName && sessionScheduledDate && timelineName
      ? `${curriculumName}_${curriculumAgeCategory}_${sessionScheduledDate}_${timelineName}_Media`
      : 'Media';

  const download = () => {
    setIsProcessing(true);

    sessionTimelineService
      .getArchiveUrl(curriculumId, timelineId, timelineCustomizationId, archiveName)
      .then(windowService.openUrl)
      .catch(handleError)
      .finally(() => setIsProcessing(false));
  };

  return (
    <ButtonComponent
      disabled={isProcessing}
      operating={isProcessing}
      onClick={download}
      data-tracking-id="download-presentation-media"
    >
      Download Presentation Media
    </ButtonComponent>
  );
};
